export default "__VITE_ASSET__BowiYduE__"